import React, { Component } from 'react';
import { Button, Col, Container, Row, Card, CardBody } from 'reactstrap';
import Butt from '../c/Butt';
import API from '../API';
import { R } from '../routes';
import { T, TraksConsumer } from '../traks';
import I18N from '../I18N';
import { classes } from '../CUtil';
import { connect } from 'react-redux';
import { OpenSignupWithSuccessCallback } from '../c/SignupLogin';
import { MarketCards, get_market_data_by_id } from './Game';
import { default_currency } from '../Site';
import { Apify } from '../Apify';
import { ordered_and_available_market_ids } from '../markets';
import store from '../store';

const DEFAULT_VOLUME_MULTIPLIER = 1.0;
const NO_VOLUME_MARKETS = ['CRYPTOCURRENCIES'];

class RadiosAndCustom extends Component {
	render() {
		var defaults = [];

		const value = this.props.parent.state[this.props.name];
		const is_custom_field = `${this.props.name}_is_custom`;
		const is_custom = !!this.props.parent.state[is_custom_field];

		const set_default = (e) => {
			const value = e.target.value;

			this.props.parent.setState({
				[this.props.name]: value,
				[is_custom_field]: false
			});
		};

		const click_custom = (e) => {
			if (this.custom_input) {
				this.custom_input.focus();
			}
			this.props.parent.setState({
				[this.props.name]: "",
				[is_custom_field]: true
			});
		};

		const set_custom_value = (value) => {
			this.props.parent.setState({
				[this.props.name]: value,
				[is_custom_field]: true
			});
		}

		const set_custom = (e) => {
			set_custom_value(e.target.value);
		};

		let a_default_is_checked = false;
		for (var i = 0; i < this.props.defaults.length; i++) {
			const item = this.props.defaults[i];
			const id = `${this.props.name}_${item.value}`;
			const checked = !is_custom && String(item.value) === String(value);
			if (checked) a_default_is_checked = true;

			defaults.push(
				<div key={id} className="ad_mobile_only">
				<div className="radio-item pr-lg-3">
					<input
						className="form-check-input"
						name={this.props.name}
						type="radio"
						id={id}
						value={item.value}
						checked={checked}
						onChange={set_default}
					/>
					<label className="form-check-label ad_3px_radius" htmlFor={id}>
						{item.text}
					</label>
				</div>
				</div>
			);
		}

		const use_custom = is_custom || !a_default_is_checked;

		const custom_id = `${this.props.name}_custom`;
		const custom_value = use_custom ? value : "";

		const correct_value = (e) => {
			const value = parseInt(e.target.value, 10);
			var corrected_value = Math.min(this.props.max, Math.max(this.props.min, value));
			if (isNaN(corrected_value)) corrected_value = this.props.min;
			if (corrected_value !== value) set_custom_value(corrected_value);
		}

		var custom_input_class = "pl-2 ad_input_newgame_custom ad_width_100px ad_height_50px";
		if (this.props.custom_error) {
			custom_input_class += " ad_input_error";
		}

		var custom;

		if (!this.props.no_custom) {
			custom = (
				<div className="radio-item">
					<input
						className="form-check-input"
						name={this.props.name}
						type="radio"
						id={custom_id}
						checked={use_custom}
						onChange={click_custom}
						onClick={click_custom}
					/>
					<label className="form-check-label-custom ad_3px_radius_no_right" htmlFor={custom_id}>
						{this.props.custom_text}&nbsp;
					</label>
					<span className="form-check-label-custom ad_3px_radius_no_left">
					<input
						placeholder={this.props.custom_placeholder}
						type="number"
						min={this.props.min}
						max={this.props.max}
						step={this.props.step}
						className={custom_input_class}
						value={custom_value}
						onChange={set_custom}
						onBlur={correct_value}
						ref={(input) => { this.custom_input = input; }}
					/>{this.props.custom_postfix}
					</span>
				</div>
			);
		}

		return (
			<div className={"ad_newgame_formgroup pt-2 " + (this.props.className || "")}>
				{defaults}
				{custom}
			</div>
		);
	}
}


const DatePick = (props) => {
	const minDate = props.minDate || new Date(props.anchor_date);
	const maxDate = props.maxDate;

	const isInviteEndCalendar = props.isInviteEndCalendar;
	
	let monthCount = props.monthCount;
	if (!monthCount && maxDate) {
	  const diffYears = maxDate.getFullYear() - minDate.getFullYear();
	  const diffMonths = maxDate.getMonth() - minDate.getMonth();
	  monthCount = diffYears * 12 + diffMonths + 1;
	}
	
	const tables = [];
	let d = new Date(minDate);
	let currentMonth = d.getMonth();
	let currentTable = { month: currentMonth, year: d.getFullYear(), rows: [] };
	let currentRow = [];
	
	while (tables.length < monthCount) {
	  const weekday = (d.getDay() + 6) % 7;
	  if (currentRow.length === 0) {
		for (let j = 0; j < weekday; j++) {
		  currentRow.push(null);
		}
	  }
	  
	  currentRow.push(new Date(d));
	  if (currentRow.length === 7) {
		currentTable.rows.push(currentRow);
		currentRow = [];
	  }
	  
	  d.setDate(d.getDate() + 1);
	  
	  if (d.getMonth() !== currentMonth) {
		if (currentRow.length > 0 && currentRow.length < 7) {
		  while (currentRow.length < 7) currentRow.push(null);
		  currentTable.rows.push(currentRow);
		  currentRow = [];
		}
		tables.push(currentTable);
		currentMonth = d.getMonth();
		currentTable = { month: currentMonth, year: d.getFullYear(), rows: [] };
	  }
	}
	
	const elements = tables.map(table => {
	  const trs = table.rows.map((row, rowIdx) => (
		<tr key={rowIdx}>
		  {row.map((date, idx) => {
			let cls = "ad_newgamedatepick_date";
			let onClick = null;
			let inner = <span />;
			if (date !== null) {
			  const outOfRange = (date < minDate) || (maxDate && date > maxDate);
			  if (outOfRange) {
				cls += " ad_newgamedatepick_date_disabled";
				inner = <span>{date.getDate()}</span>;
			  } else {
				if (
				  props.chosen_date &&
				  date.getFullYear() === props.chosen_date.getFullYear() &&
				  date.getMonth() === props.chosen_date.getMonth() &&
				  date.getDate() === props.chosen_date.getDate()
				) {
				  cls += " ad_newgamedatepick_date_chosen";
				  inner = <span>{date.getDate()}</span>;
				} else {
				  cls += " ad_newgamedatepick_date_not_chosen";
				  onClick = () => props.on_set_date(date);
				  inner = <span>{date.getDate()}</span>;
				}
			  }
			}
			return <td key={idx} className={cls} onClick={onClick}>{inner}</td>;
		  })}
		</tr>
	  ));
	  
	  const weekday_elements = [];
	  for (let i = 0; i < 7; i++) {
		weekday_elements.push(<th key={i}>{I18N.short_weekday(i)}</th>);
	  }
	  
	  return (
		<div key={`${table.year}-${table.month}`} className="ad_newgamedatepick">
		  <h1>{I18N.month(table.month)}</h1>
		  <table>
			<thead>
			  <tr>{weekday_elements}</tr>
			</thead>
			<tbody>{trs}</tbody>
		  </table>
		</div>
	  );
	});
	
	if (isInviteEndCalendar) {
	  return (
		<div>
		  <Row className="justify-content-start px-4">{elements}</Row>
		  <Row>
			<Col md="12" className="px-md-4">
			  <small><T>Invites will close at 8:00 AM on the chosen date</T></small>
			  <br/>
			</Col>
		  </Row>
		</div>
	  );
	}
	return (
	  <div>
		<Row className="justify-content-start px-4">{elements}</Row>
		<Row>
		  <Col md="12" className="px-md-4">
			<small><T>The game will start at 8:00 AM on the chosen date</T></small>
			<br/>
		  </Col>
		</Row>
	  </div>
	);
  };

const mk_market_select_key = (market_id) => "market_select_" + market_id;

class GameParams extends Component {
	constructor(props) {
		super(props);


		var anchor_date = new Date();
		anchor_date.setDate(anchor_date.getDate() + 1);

		const params_ex = props.params;
		let name = "";
		let brokerage_pct = 0;
		let max_amount_per_stock = "nolimit"

		let bankroll = 250000;
		let use_volume = false;
        let use_risk_values = false;
		let trade_amount_activated = false;
		let trade_amount = 50;
        let use_stock_info = false;
		if (params_ex) {
			const params = params_ex.Params;
			name = params.Name;
			brokerage_pct = params.BrokeragePct;
			bankroll = params_ex.BankrollInitialAmount;
			if (params.MaxAmountPerStock) {
				if (Math.round(params.MaxAmountPerStock) === Math.round(bankroll * 0.20)) {
					max_amount_per_stock = "20%";
				} else {
					max_amount_per_stock = params.MaxAmountPerStock + "";
				}
			}
			use_volume = params.VolumeMultiplier > 0;
            use_risk_values = params.RiskValues > 0;
            use_stock_info = params.StockInfo > 0;
			if (params.TradeAmount) {
				trade_amount = params.TradeAmount
				trade_amount_activated = params.TradeAmountActivated
			}
		}

		let inviteEndDate = null;
		if (
		props.mode === "edit" &&
		props.params &&
		props.params.Params &&
		props.params.Params.InviteEndTs
		) {
		inviteEndDate = new Date(props.params.Params.InviteEndTs);
		}

		let gameEndDate = null;
		if (
		props.mode === "edit" &&
		props.params &&
		props.params.Params &&
		props.params.Params.EndTime
		) {
		gameEndDate = new Date(props.params.Params.EndTime);
		}

		function isDefaultDate(date) {
			if (!date) return false; 
			return (
			  date.getFullYear() === 1 &&
			  date.getMonth() === 0 && 
			  date.getDate() === 1
			);
		  }

		  let inviteendcustomValue = "1";

		  if (props.mode !== "edit") {
			inviteendcustomValue = "0";
		  } else {
			let inviteEndDate = null;
			if (
			  props.mode === "edit" &&
			  props.params &&
			  props.params.Params &&
			  props.params.Params.InviteEndTs
			) {
			  inviteEndDate = new Date(props.params.Params.InviteEndTs);
			}
		  
			let gameEndDate = null;
			if (
			  props.mode === "edit" &&
			  props.params &&
			  props.params.Params &&
			  props.params.Params.EndTime
			) {
			  gameEndDate = new Date(props.params.Params.EndTime);
			}
		  
			if (inviteEndDate && gameEndDate) {
			  if (
				inviteEndDate.getTime() === gameEndDate.getTime() ||
				isDefaultDate(inviteEndDate)
			  ) {
				inviteendcustomValue = "0";
			  }
			}
		  }

		let market_state = {};
		if (props.mode === "new") {
			for (const market_id of ordered_and_available_market_ids) {
                // Apply when free users only have access to home market
                /*if (market_id === default_market) {
                    market_state[mk_market_select_key(market_id)] = true;
                } else {
                    market_state[mk_market_select_key(market_id)] = false;
                }*/
                market_state[mk_market_select_key(market_id)] = true;
            }

			const default_false_market_ids = ["CRYPTOCURRENCIES", "COMMODITIES", "AT_STOCK", "ETFS", "INDEXES", "FUNDS"];


			for (const market_id of default_false_market_ids) market_state[mk_market_select_key(market_id)] = false;
		} else if (props.mode === "edit") {
			for (const market_id of ordered_and_available_market_ids) market_state[mk_market_select_key(market_id)] = false;
			for (const market_id of props.params.Params.Markets) market_state[mk_market_select_key(market_id)] = true;
		}

		this.initial_market_state = {...market_state};
        
		this.state = {
			name,
			gametime: 30,
			gamestartcustom: 0,
			inviteendcustom: inviteendcustomValue,
            number_of_players: 10,
			gamestartcustom_anchor_date: anchor_date,
			gamestartcustom_chosen_date: anchor_date,
			inviteendcustom_anchor_date: anchor_date,
			inviteendcustom_chosen_date: inviteEndDate || anchor_date,
			bankroll,
			brokerage_pct,
			...market_state,
			currency: default_currency,
			max_amount_per_stock,
			use_volume,
            use_risk_values,
            allowed_beta_values: props.me && props.me.Subscription ? props.me.Subscription.includes('pro', 'enterprise') : false,
            user_is_premium: props.me && props.me.Subscription ? props.me.Subscription.includes('pro', 'enterprise') : false,
			trade_amount_activated,
			trade_amount,
            use_stock_info
		};

		/* hack for debugging purposes */
		window.set_game_currency = (currency) => {
			this.setState({currency});
			return "OKIDOKI";
		};

		this.NoEdit = props.mode === "edit" ? props => null : props => props.children;
	}

    componentDidUpdate(prevProps) {
        if (this.props.cart !== prevProps.cart) {
            const cart = this.props.cart;

            if (cart.completed) {
                if (this.props.mode === 'new') {
                    this.props.me.Subscription = 'pro';
                } else if (this.props.mode === 'edit') {
                    this.props.me.Subscription = 'pro';
                    this.props.params.Params.GameType = 'pro';
                }

                this.props.cart.completed = false;
                this.forceUpdate();
            }
        }
    }

	render() {
		const mk_market_card_props = (name, isPremium) => {
			const state_key = mk_market_select_key(name);
			return {
				selected: this.state[state_key],
				toggle: (e) => {
					e.preventDefault();
					
					this.setState((prev_state) => ({[state_key]: !prev_state[state_key]}));
				}
			};
		};

		const simple_change = (e) => {
			this.setState({
				[e.target.name]: e.target.value
			});
		};

		const simple_checkbox_change = (e) => {
			this.setState({
				[e.target.name]: e.target.checked
			});
		};

		var name_input_class = "ad_input ad_3px_radius ad_height_60px w-75 pl-3";
		if (this.state.invalid_input === "name") {
			name_input_class += " ad_input_error";
		}

		const state_invalid_input = this.state.invalid_input;
		const this_parent = this;

		const crypto_warning_text =
			(this.state.market_select_CRYPTOCURRENCIES && !this.initial_market_state.market_select_CRYPTOCURRENCIES)
			? <div className="ad_trade_notice"><T>*Crypto currencies are very volatile and alters the game dynamics</T></div>
			: null;

        const risk_value_warning_text = (this.state.use_risk_values)
            ? <div className='ad_trade_notice'><T>*With the addition of risk values, only assets with a risk score can be included in the game.</T></div> 
            : null;

		let no_volume_warning_text = null;
		if (this.state.use_volume) {
			let no_volume_markets = [];
			for (let market of NO_VOLUME_MARKETS) {
				if (this.state[mk_market_select_key(market)]) {
					no_volume_markets.push(market);
				}
			}
			if (no_volume_markets.length > 0) {
				let markets = no_volume_markets.map((id) => {
					let data = get_market_data_by_id(id);
					let content = id;
					if (data) {
						content = <span className="px-3"><img alt="" className="ad_market_card_smaller_img mr-1" src={data.img} />{data.title}</span>;
					}
					return <span key={id} className="ad_no_volume_market py-1 mr-2">{content}</span>;
				});
				no_volume_warning_text = (
					<div className="ad_trade_notice mr-2">
						<div>
							<T>*Volume gameplay is enabled, but the following markets have no volume data, and will be treated as having infinite volume:</T>
						</div>
						<div className="py-3">
							{markets}
						</div>
					</div>
				);
			}
		}

		var gameStartCalendar;
		if (this.state.gamestartcustom === "1") {
			const on_set_date = (date) => {
				this.setState({gamestartcustom_chosen_date: date});
			};
			gameStartCalendar = <DatePick
				anchor_date={this.state.gamestartcustom_anchor_date}
				chosen_date={this.state.gamestartcustom_chosen_date}
				on_set_date={on_set_date}
				monthCount={4}
			/>;
		}

		var inviteEndCalendar;
		if (this.state.inviteendcustom === "1") {
		const on_set_date = (date) => {
			this.setState({ inviteendcustom_chosen_date: date });
		};

		let maxDate;
		if (this.props.mode === "edit" &&
			this.props.params &&
			this.props.params.Params &&
			this.props.params.Params.EndTime) {
		// When editing, use the EndTime from props
		const end_time = new Date(this.props.params.Params.EndTime);
		const diff = end_time.getTime() - this.state.gamestartcustom_chosen_date.getTime();
		maxDate = new Date(this.state.gamestartcustom_chosen_date.getTime() + diff);
		} else {
		// For new games, calculate maxDate based on gametime (in days)
		maxDate = new Date(
			this.state.gamestartcustom_chosen_date.getTime() +
			this.state.gametime * 24 * 60 * 60 * 1000
		);
		}

		inviteEndCalendar = <DatePick
			anchor_date={this.state.inviteendcustom_anchor_date}
			chosen_date={this.state.inviteendcustom_chosen_date}
			on_set_date={on_set_date}
			minDate={this.state.gamestartcustom_chosen_date} 
			maxDate={maxDate} 
			isInviteEndCalendar = {true}
		/>;
		}

		const other_txt = <T>Other</T>;
		const nolimit_txt = <T>No limit</T>;
		var amount_txt = <T>Amount</T>;

		const validate_name = () => {
			if (this.state.name.trim().length === 0) {
				this.setState({invalid_input: "name"});
				// TODO focus? how?
				return false;
			}
			return true;
		};

		const validate_and_get_brokerage_pct = () => {
			const brokerage_pct = parseFloat(this.state.brokerage_pct);
			if (isNaN(brokerage_pct)) {
				this.setState({invalid_input: "brokerage_pct"});
				// TODO focus? how?
				return undefined;
			} else {
				return brokerage_pct;
			}
		};

		const get_selected_markets = () => {
			return ordered_and_available_market_ids.filter(x => this.state[mk_market_select_key(x)]);
		};

		const get_max_amount_per_stock = () => {
			var v = this.state.max_amount_per_stock;
			if (v === "nolimit") {
				return 0;
			} else if (v.slice(v.length-1) === "%") {
				const pct = parseInt(v.slice(0, v.length-1), 10);
				return Math.floor(this.state.bankroll * pct * 0.01);
			} else {
				return parseInt(this.state.max_amount_per_stock, 10);
			}
		};

		let header, submit_btn, not_enough_keys_warning_text;

        const isPremiumFeatureActived = this.state.use_risk_values || this.state.inviteendcustom === "1" || this.state.use_stock_info || get_selected_markets().some(market => ['CRYPTOCURRENCIES', 'COMMODITIES', 'ETFS', 'INDEXES', 'FUNDS'].includes(market));
		if (this.props.mode === "new") {
			header = (
				<React.Fragment>
					<Row className="ad_light_gray_bg">
						<Col className="mt-2" align="center">
							<img src="/gfx/pokal_m_flimmer-0.svg" className="img-fluid" alt="Time for a new game!"/>
						</Col>
					</Row>
					<Row className="ad_light_gray_bg">
						<Col className="text-center">
							<h1><T>Create game</T></h1>
						</Col>
					</Row>
					<Row className="pt-3 justify-content-center ad_light_gray_bg ad_thin_bottom">
						<Col md="6" className="text-center ad_p_large ad_gray_fg">
							<T>Invite your friends and find out who is the best investor. Invest in stocks, crypto-currencies and more</T>
						</Col>
					</Row>
				</React.Fragment>
			);

			let submit = (e) => {
				e.preventDefault();

				if (!validate_name()) return;

				var start_ts, end_ts, invite_end_ts;
				if (this.state.gamestartcustom === "1") {
					var start_date = new Date(this.state.gamestartcustom_chosen_date);
					start_date.setHours(8);
					start_date.setMinutes(0);
					start_date.setSeconds(0);
					start_date.setMilliseconds(0);
					start_ts = (start_date.getTime() / 1000) | 0;
				}

				if (this.state.inviteendcustom === "1") {
					invite_end_ts = Math.floor(new Date(this.state.inviteendcustom_chosen_date).getTime() / 1000);
				  }

				const duration_days = parseInt(this.state.gametime, 10);
				if (isNaN(duration_days)) {
					this.setState({invalid_input: "gametime"});
					// TODO focus? how?
					return;
				} else {
					end_ts = (start_ts ? start_ts : (Date.now()/1000)) + duration_days * 24 * 60 * 60;
				}

				const amount = parseInt(this.state.bankroll, 10);
				if (isNaN(amount)) {
					this.setState({invalid_input: "bankroll"});
					// TODO focus? how?
					return;
				}

				const brokerage_pct = validate_and_get_brokerage_pct();
				if (brokerage_pct === undefined) return;

				const markets = get_selected_markets();

				const pay_dividends = false; // TODO GUI

				let data = {
					name: this.state.name,
					amount_currency: this.state.currency,
					end_ts,
					brokerage_pct,
					amount,
					markets,
					pay_dividends: pay_dividends ? 1 : 0,
					max_amount_per_stock: get_max_amount_per_stock(),
                    risk_values: this.state.use_risk_values ? 1 : 0,
					trade_amount_activated: this.state.trade_amount_activated ? 1 : 0,
                    stock_info_activated: this.state.use_stock_info ? 1 : 0
				};

				if (invite_end_ts) {
					data.invite_end_ts = invite_end_ts;
				}

				if (invite_end_ts === undefined) {
					data.invite_end_ts = end_ts;
				}

				if (this.state.trade_amount_activated) {
					const trade_amount = parseInt(this.state.trade_amount, 10);
					if (isNaN(trade_amount)) {
						this.setState({invalid_input: 'trade_amount'})
					}

					data.trade_amount = trade_amount
				}

				if (this.state.use_volume) {
					data.volume_multiplier = DEFAULT_VOLUME_MULTIPLIER;
				}

				if (start_ts) data.start_ts = start_ts;
				if (window.game_start_ts) data.start_ts = window.game_start_ts; // XXX temporary ability to set start time from JS console

				const post_new_game = () => {
					API.post("/a/new_game", data, (new_game_id) => {
						R.replace("/game/:new_game_id", {new_game_id});
					})
				};

				if (this.props.me) {
					post_new_game();
				} else {
					OpenSignupWithSuccessCallback(post_new_game);
				}
			};
            
            let submitButtonText = <T>Start game</T>

            if ((isPremiumFeatureActived && this.props.me.Subscription === 'free')) {
                not_enough_keys_warning_text = 
                <Row className="justify-content-center">
                    <Col className="bg-white px-md-2 pt-4">
                        <div className="form-check pt-3 pb-5 text-center">
                            <div className="ad_trade_notice"><T>*To create a game with premium features, you'll need to purchase Premium first.</T></div>
                        </div>
                    </Col>
                </Row>
                submit = (e) => {
                    store.dispatch_value("show_cart_game_upgrade", {
                        completed: false
                    })
                    store.dispatch_value("show_cart", true);
                }
                submitButtonText = <T>Upgrade</T>
            } else {
                not_enough_keys_warning_text = null
            }

			submit_btn = (
				<Row className="justify-content-center">
					<Col className="bg-white px-md-4 pt-4">
						<div className="form-check pt-3 pb-5 text-center">
							<Button onClick={submit} className="ad_new_game_button py-2 px-4">{submitButtonText}</Button>
						</div>
					</Col>
				</Row>
			);
		} else if (this.props.mode === "edit") {
			header = (
				<React.Fragment>
					<Row className="ad_light_gray_bg">
						<Col className="mt-2" align="center">
							<img src="/gfx/pokal_for_edit-0.svg" className="img-fluid" alt="Edit game!"/>
						</Col>
					</Row>
					<Row className="ad_light_gray_bg">
						<Col className="text-center">
							<h1><T>Edit game</T></h1>
						</Col>
					</Row>
					<Row className="pt-3 justify-content-center ad_light_gray_bg ad_thin_bottom">
						<Col md="6" className="text-center ad_p_large ad_gray_fg">
							<T>Here you can edit some of the settings for the game.</T>
						</Col>
					</Row>
				</React.Fragment>
			);
			let submit = (e) => {
				e.preventDefault();
				if (!validate_name()) return;

				const brokerage_pct = validate_and_get_brokerage_pct();
				if (brokerage_pct === undefined) return;

				const max_amount_per_stock = get_max_amount_per_stock();

				const markets = get_selected_markets();

				const data = {
					id: this.props.game_id,
					params: {
						Name: this.state.name,
						MaxAmountPerStock: max_amount_per_stock,
						BrokeragePct: brokerage_pct,
						Markets: markets,
						VolumeMultiplier: this.state.use_volume ? DEFAULT_VOLUME_MULTIPLIER : 0,
                        RiskValues: this.state.use_risk_values,
                        StockInfo: this.state.use_stock_info
					},
				};
				
				if (this.state.inviteendcustom === "1") {
					const invite_end_str = new Date(this.state.inviteendcustom_chosen_date).toISOString();
					data.params.InviteEndTs = invite_end_str;
				} else {
					data.params.InviteEndTs = this.props.params.Params.EndTime;
				}

				API.post("/a/game_params", data, () => {
					R.go("/game/:game_id", {game_id: this.props.game_id});
				});
			};
            let submitButtonText = <T>Edit game</T>
            not_enough_keys_warning_text = null

			submit_btn = (
				<Row className="justify-content-center">
					<Col className="bg-white px-md-4 pt-4">
						<div className="form-check pt-3 pb-5 text-center">
							<Butt onClick={submit} className="ad_rbtn">{submitButtonText}</Butt>
						</div>
					</Col>
				</Row>
			);
		}

		const { NoEdit } = this;

		const locked_markets = this.props.params && this.props.params.TradedMarkets ? this.props.params.TradedMarkets : [];
		const locked_reason = <T>This market has already been traded in the game and cannot be deselected now</T>;

		const initial_bankroll_defaults = [250000, 1000000].map((value) => ({
			"value": value,
			"text": I18N.floatval_unit(value, 0, default_currency),
		}));

		return (
			<div className="container-fluid">
				{header}
				<form onSubmit={(e) => { e.preventDefault(); }}>
				<Container fluid className="p-0">
					<Row className="justify-content-center bg-white pb-5">
					<Col lg="7" className="bg-white ad_m_negative_medium pb-5 ad_shadow_new_game">

					<Row className="justify-conteat-center">
						<Col md="12" className="px-md-4 pt-4">
							<img alt="" className="ad_logo_list" src="/gfx/cup-frontpage-color-0.svg"/><span className="ad_120_bold pl-2"><T>Name of the game</T></span>
							<p>
							<small><T>The name is used for invites and game overview</T></small><br/>
							</p>
							<div className="ad_newgame_formgroup pt-2">
								<div className="input-group">
									<input
										name="name"
										value={this.state.name}
										onChange={simple_change}
										className={name_input_class}
										type="text"
									/>
								</div>
							</div>
						</Col>
					</Row>

					<NoEdit>
						<Row className="justify-content-center">
							<Col md="12" className="px-md-4 pt-4">
								<img alt="" className="ad_logo_list" src="/gfx/calendar-color-0.svg"/><span className="ad_120_bold pl-2"><T>Game start</T></span>
								<p>
								<small><T>When the game starts</T></small><br/>
								</p>
								<T><RadiosAndCustom
									name="gamestartcustom"
									parent={this_parent}
									no_custom={true}
									defaults={[
										{"value": "0", "text": "Start game now"},
										{"value": "1", "text": "Choose a start date"},
									]}
								/></T>
							</Col>
						</Row>
						{gameStartCalendar}
					</NoEdit>

					<NoEdit>
						<Row className="justify-content-center">
							<Col md="12" className="px-md-4 pt-4">
								<img alt="" className="ad_logo_list" src="/gfx/game-time-color-0.svg"/><span className="ad_120_bold pl-2"><T>Game time</T></span>
								<p>
								<small><T>For how long will the game run</T></small><br/>
								</p>
								<T><RadiosAndCustom
									name="gametime"
									parent={this_parent}
									defaults={[
										{"value": 30, "text": "30 days"},
										{"value": 90, "text": "90 days"},
									]}
									custom_text="Other (max 365)"
									custom_placeholder="days"
									custom_error={state_invalid_input === "gametime"}
									min={1}
									max={365}
								/></T>
							</Col>
						</Row>
					</NoEdit>

					<Row className="justify-content-center">
							<Col md="12" className="px-md-4 pt-4 new_game_premium px-md-4 pt-4">
								<img alt="" className="ad_logo_list" src="/gfx/calendar-color-0.svg"/><span className="ad_120_bold pl-2"><T>Game Registration Closes</T></span><div className="ad_game_premium_marker px-2">Premium</div>
								<p>
								<small><T>The date when registration for the game closes</T></small><br/>
								</p>
								<T><RadiosAndCustom
									name="inviteendcustom"
									parent={this_parent}
									no_custom={true}
									is_premium_feature={true}
									defaults={[
										{ "value": "0", "text": "None" },
										{"value": "1", "text": "Select registration closing date"},
									]}
								/></T>
							</Col>
						</Row>
						{inviteEndCalendar}

					<Row className="justify-content-center">
						<Col md="12" className="px-md-4 pt-4">
							<img alt="" className="ad_logo_list" src="/gfx/players-icon-0.svg" /><span className="ad_120_bold pl-2"><T>Number of players</T></span>
							<p>
								<small><T>You can play with up to 30 participants for free</T></small><br/>
							</p>
							<T><RadiosAndCustom
									name="number_of_players"
									parent={this_parent}
									defaults={[
										{"value": 10, "text": "10 players"},
										{"value": 20, "text": "20 players"},
                                        {"value": 30, "text": "Under 30"},
									]}
									custom_text="Other"
									custom_placeholder="players"
									custom_error={state_invalid_input === "number_of_players"}
									min={1}
									max={100000}
								/></T>
						</Col>
					</Row>

					<NoEdit>
						<Row className="justify-content-center">
							<Col md="12" className="px-md-4 pt-4">
								<img alt="" className="ad_logo_list" src="/gfx/bankroll-icon-color-0.svg"/><span className="ad_120_bold pl-2"><T>Bankroll</T></span>
								<p>
								<small><T>How much money each player will get to begin with</T></small><br/>
								</p>
								<T><RadiosAndCustom
									name="bankroll"
									parent={this_parent}
									defaults={initial_bankroll_defaults}
									custom_text="Other"
									custom_placeholder="Amount"
									custom_error={state_invalid_input === "bankroll"}
									min={1}
									max={10000000}
								/></T>
							</Col>
						</Row>
					</NoEdit>

					<Row className="justify-content-center">
						<Col md="12" className="px-md-4 pt-4">
							<img alt="" className="ad_logo_list" src="/gfx/volume-icon-color-0.svg" /><span className="ad_120_bold pl-2"><T>Trade volume reflection</T></span>
							<p>
								<small><T>Use volume in real markets to reflect how much can be bought in your game.</T></small><br/>
							</p>
							<div className="text-left">
								<label className="ad_custom_checkmark_container" style={{paddingTop: "1px"}}>
									<input
										name="use_volume"
										type="checkbox"
										id="new_game_volume_option"
										checked={this.state.use_volume}
										onChange={simple_checkbox_change}
									/>
									<span className="ad_large_own_checkmark" />
								</label>
								<label htmlFor="new_game_volume_option" className="d-inline">
									<span><T>Use volume for markets that support it</T></span>
								</label>
							</div>
						</Col>
					</Row>

                    <Row className="justify-content-center">
						<Col md="12" className="new_game_premium px-md-4 pt-4">
							<img alt="" className="ad_logo_list" src="/gfx/volume-icon-color-0.svg" /><span className="ad_120_bold pl-2"><T>Leaderboard risk values</T></span><div className="ad_game_premium_marker px-2">Premium</div>
							<p>
								<small><T>Enable risk values so you can compete on both regular returns and risk-adjusted returns.</T></small><br/>
							</p>
							<div className="text-left">
								<label className="ad_custom_checkmark_container" style={{paddingTop: "1px"}}>
									<input
										name="use_risk_values"
										type="checkbox"
										id="new_game_beta_values_option"
										checked={this.state.use_risk_values}
										onChange={simple_checkbox_change}
									/>
									<span className="ad_large_own_checkmark" />
								</label>
								<label htmlFor="new_game_beta_values_option" className="d-inline">
									<span><T>Use risk values for markets that support it</T></span>
								</label>
							</div>
						</Col>
					</Row>

					<Row className="justify-content-center">
    					<Col md="12" className="new_game_premium px-md-4 pt-4">
        					<img alt="" className="ad_logo_list" src="/gfx/information-about-assets-icon-0.svg" />
        						<span className="ad_120_bold pl-2"><T>Information about assets</T></span><div className="ad_game_premium_marker px-2">Premium</div>
        							<p>
            							<small><T>Asset information includes the options below and is a good way</T></small><br/>
        							</p>
                                <div className="text-left">
                                    <label className="ad_custom_checkmark_container" style={{paddingTop: "1px"}}>
                                        <input
                                            name="use_stock_info"
                                            type="checkbox"
                                            id="new_game_game_type_option"
                                            checked={this.state.use_stock_info}
                                            onChange={simple_checkbox_change}
                                        />
                                        <span className="ad_large_own_checkmark" />
                                    </label>
                                    <label htmlFor="new_game_game_type_option" className="d-inline">
                                        <span><T>Use information about assets</T></span>
                                    </label>
                                </div>
								<Col>
									<Row>
										<Card className="new_game_premium_assets">
											<CardBody>
												<img alt="checkmark" src="https://static.aktiedysten.dk/gfx/checkmark-icon-2023-0.svg"/>
												<p><T>Company information</T></p>
											</CardBody>
										</Card>
										<Card className="new_game_premium_assets">
											<CardBody>
												<img alt="checkmark" src="https://static.aktiedysten.dk/gfx/checkmark-icon-2023-0.svg"/>
												<p><T>Industry indication</T></p>
											</CardBody>
										</Card>
										<Card className="new_game_premium_assets">
											<CardBody>
												<img alt="checkmark" src="https://static.aktiedysten.dk/gfx/checkmark-icon-2023-0.svg"/>
												<p><T>Financial information</T></p>
											</CardBody>
										</Card>
										<Card className="new_game_premium_assets">
											<CardBody>
												<img alt="checkmark" src="https://static.aktiedysten.dk/gfx/checkmark-icon-2023-0.svg"/>
												<p><T>Key figures</T></p>
											</CardBody>
										</Card>
									</Row>
								</Col>
						</Col>
					</Row>

					<Row className="justify-content-center">
    					<Col md="12" className="new_game_premium px-md-4 pt-4">
        					<img alt="" className="ad_logo_list" src="/gfx/volume-icon-color-0.svg" />
        						<span className="ad_120_bold pl-2"><T>Player trade limits</T></span><div className="ad_game_premium_marker px-2">Premium</div>
        							<p>
            							<small><T>Max amount of trades for each player</T></small><br/>
        							</p>
							<div className="text-left">
								<label className="ad_custom_checkmark_container" style={{ paddingTop: "1px" }}>
									<input
										name="trade_amount_activated"
										type="checkbox"
										id="new_game_max_trade_option"
										checked={this.state.trade_amount_activated}
										onChange={simple_checkbox_change}
									/>
									<span className="ad_large_own_checkmark" />
								</label>
								<label htmlFor="new_game_max_trade_option" className="d-inline">
									<span><T>Limit the maximum number of trades per player</T></span>
								</label>
							</div>
						</Col>
					</Row>


					{this.state.trade_amount_activated && (
						<Row className="justify-content-center">
							<Col md="12" className="px-md-4 pt-4">
								<img alt="" className="ad_logo_list" src="/gfx/max-amount-one-equity-0.svg"/>
								<span className="ad_120_bold pl-2"><T>Maximum amount of trades</T></span>
								<p>
									<small><T>How many trades for each player</T></small><br/>
								</p>
								<T><RadiosAndCustom
									name="trade_amount"
									parent={this_parent}
									defaults={[
										{"value": 50, "text": "50 trades"},
										{"value": 100, "text": "100 trades"},
									]}
									custom_text="Other (max x)"
									custom_placeholder="Enter max trades"
									custom_error={state_invalid_input === "trade_amount"}
									min={1}
									max={500}
								/></T>
							</Col>
						</Row>
				    )}



					<Row className="justify-content-center">
						<Col md="12" className="px-md-4 pt-4">
							<img alt="" className="ad_logo_list" src="/gfx/max-amount-one-equity-0.svg"/><span className="ad_120_bold pl-2"><T>Max. amount in one equity</T></span>
							<p>
							<small><T>How much is the maximum amount that a player kan invest in one equity?</T></small><br/>
							</p>
							<RadiosAndCustom
								name="max_amount_per_stock"
								parent={this_parent}
								defaults={[
									{"value": "nolimit", "text": nolimit_txt},
									{"value": "20%", "text": <span>{I18N.floatval_unit(this.state.bankroll*0.2, 0, this.state.currency)} (20%)</span>},
								]}
								custom_text={other_txt}
								custom_placeholder={this.props.render_static(amount_txt)}
								custom_error={state_invalid_input === "max_amount_per_stock"}
								min={1}
								max={10000000}
							/>
						</Col>
					</Row>

					<Row className="justify-content-center">
						<Col md="12" className="px-md-4 pt-4">
							<img alt="" className="ad_logo_list" src="/gfx/brokerage-color-0.svg"/><span className="ad_120_bold pl-2"><T>Brokerage</T></span>
							<p>
							<small><T>How big a percentage of a trade to pay in broker commission</T></small><br/>
							</p>
							<T><RadiosAndCustom
								name="brokerage_pct"
								parent={this_parent}
								defaults={[
									{"value": 0, "text": "None"},
									{"value": 0.15, "text": "0.15%"},
								]}
								custom_text="Other"
								custom_postfix="%&nbsp;&nbsp;"
								custom_placeholder="pct."
								custom_error={state_invalid_input === "brokerage_pct"}
								min={0}
								max={50}
								step={0.01}
							/></T>
						</Col>
					</Row>

					<Row className="justify-content-center">
						<Col md="12" className="px-md-4 pt-4">
							<img alt="" className="ad_logo_list" src="/gfx/markets-color-0.svg"/><span className="ad_120_bold pl-2"><T>Markets</T></span>
							<p>
							<small><T>Choose which markets the game players can invest in</T></small>
							</p>
						</Col>
					</Row>

                    <Row className="justify-content-center">
                        <Col md="12" className="px-md-4 pt-4">
                            {risk_value_warning_text}
                        </Col>
                    </Row>

					<MarketCards mk_market_card_props={mk_market_card_props} locked_markets={locked_markets} locked_reason={locked_reason} section="stock" justify="left" />

                    <Row className="justify-content-center">
						<Col md="12" className="px-md-4 pt-4">
							<img alt="" className="ad_logo_list" src="/gfx/assets-icon-0.svg"/><span className="ad_120_bold pl-2"><T>Assets</T></span>
						</Col>
					</Row>

                    <MarketCards mk_market_card_props={mk_market_card_props} locked_markets={locked_markets} locked_reason={locked_reason} section="assets" justify="left" />

                    <Row className="justify-content-center">
						<Col md="12" className="px-md-4 pt-4">
							<img alt="" className="ad_logo_list" src="/gfx/commodity-icon-0.svg"/><span className="ad_120_bold pl-2"><T>Commodity Market</T></span>
						</Col>
					</Row>

                    <MarketCards mk_market_card_props={mk_market_card_props} locked_markets={locked_markets} locked_reason={locked_reason} section="commodity" justify="left" />

                    <Row className="justify-content-center">
						<Col md="12" className="px-md-4 pt-4">
							<img alt="" className="ad_logo_list" src="/gfx/crypto-icon-color-0.svg"/><span className="ad_120_bold pl-2"><T>Crypto</T></span>
							{crypto_warning_text}
                            {no_volume_warning_text}
						</Col>
					</Row>

                    <MarketCards mk_market_card_props={mk_market_card_props} locked_markets={locked_markets} locked_reason={locked_reason} section="crypto" justify="left" />

                    {not_enough_keys_warning_text}
					{submit_btn}

					</Col>
					</Row>
				</Container>
				</form>
			</div>
		);
	}
}

const GameParamsOuter = connect(
	(state) => ({
        me: state.me,
        cart: state.show_cart_game_upgrade
    })
)((props) => <TraksConsumer><GameParams {...props}/></TraksConsumer>);

const NewGame = (props) => <GameParamsOuter mode="new" {...props}/>

const EditGame = Apify("/a/game_params")
	.with_response_prop("params")
	.with_query_from_props(props => ({id: props.game_id}))
.wrap((props) => <GameParamsOuter mode="edit" {...props}/>)

export {
	NewGame,
	EditGame,
}



// WEBPACK FOOTER //
// ./src/c/GameParams.js